/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {TombstoneRipParsedData} from "./TombstoneRipParsedData";
import {ITombstoneRipInitData, ISymbolValues} from "./ITombstoneRipData";
import {TombstoneRipDataParser} from "./TombstoneRipDataParser";

export class TombstoneRipParsedInitData extends TombstoneRipParsedData {

    public readonly betLines:number[][];
    public readonly symbolValues:ISymbolValues;
    public readonly isRestoreState:boolean;

    constructor(rawData:ITombstoneRipInitData, parser:TombstoneRipDataParser) {
        super(rawData, parser);

        this.betLines = rawData.betLines;
        this.symbolValues = rawData.symbolValues;
        this.isRestoreState = rawData.isRestoreState;
    }
}